export * from './properties';
export { getConfiguration } from './RemoteConfig';
